export { default as JobDetails } from './JobDetails';


// WEBPACK FOOTER //
// ./src/screens/JobDetails/index.js